import React,{useState,useEffect} from 'react'
import withRouter from '../../Common/withRouter';
import { Container, Row, Col, Card, Form, Button,Alert,Spinner } from 'react-bootstrap';
import logo from "../../assets/images/bim-logo.png"
import {Link} from 'react-router-dom';
import AuthCarousel from './AuthCarousel';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { loginUser, resetLoginFlag } from '../../slices/thunk';
import * as Yup from "yup";
import {useTranslation} from "react-i18next";
import AuthFooter from "../../Layout/AuthFooter";

const Login = (props:any) => {
  const {t} = useTranslation();
  document.title = t('Login.title');

  const dispatch: any = useDispatch();
    const selectAccountAndLogin = createSelector(
        (state: any) => state.Account,
        (state: any) => state.Login,
        (account:any, login:any) => ({
          user: account.user,
          error: login.error,
          loading: login.loading,
          errorMsg: login.errorMsg,
        })
      );
      
    const { user, error, loading, errorMsg } = useSelector(selectAccountAndLogin);

    const [userLogin, setUserLogin] = useState<any>([]);
   

    useEffect(() => {
        if (user && user) {
            setUserLogin({
                email: user.email || user.username || '',
                password: user.password || ''
            });
        }
    }, [user]);

    //  validation
    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    

    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: userLogin.email ||"admin@demo.com.tr" || '',
            password: userLogin.password ||"Demo123." || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required(t('email_error')),
            password: Yup.string().required(t('password_error')),
        }),
        onSubmit: (values:any) => {
            dispatch(loginUser(values, props.router.navigate));
        }
    });



    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);
    
  return (
    <React.Fragment>
      <div className="account-pages">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={11}>
                            <div className="auth-full-page-content d-flex min-vh-100 py-sm-5 py-4">
                                <div className="w-100">
                                    <div className="d-flex flex-column h-100 py-0 py-xl-4">

                                        <div className="text-center mb-5">
                                            <Link to="/">
                                                <span className="logo-lg">
                                                    <img src={logo} alt="" height="128" />
                                                </span>
                                            </Link>
                                        </div>

                                        <Card className="my-auto overflow-hidden">
                                            <Row className="g-0">
                                                <Col lg={6}>
                                                    <Card.Body className="p-lg-5 p-4">
                                                        <div className="text-center">
                                                            <h5 className="mb-0">{t('Login.header')}</h5>
                                                            <p className="text-muted mt-2">{t('Login.subheader')}</p>
                                                        </div>

                                                        <div className="mt-4">
                                                        {error && error ? (<Alert variant="danger"> {error} </Alert>) : null}
                                                        <Form
                                                            action='#'
                                                            onSubmit={(e) => {
                                                                e.preventDefault();
                                                                validation.handleSubmit();
                                                                return false;
                                                            }}
                                                        >
                                                                <Form.Group className="mb-3" controlId="username">
                                                                    <Form.Label>{t('Login.email')}</Form.Label>
                                                                    <div className="position-relative">
                                                                    <Form.Control
                                                                        type="email"
                                                                        name='email'
                                                                        className="form-control bg-light border-light password-input"
                                                                        placeholder="Enter username"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.email || ""}
                                                                        isInvalid={
                                                                            validation.touched.email && validation.errors.email ? true : false
                                                                        }

                                                                    />
                                                                    {validation.touched.email && validation.errors.email ? (
                                                                        <Form.Control.Feedback type="invalid">{validation.errors.email}</Form.Control.Feedback>
                                                                    ) : null}
                                                                </div>
                                                                </Form.Group>                                                                

                                                                <Form.Group className="mb-3" controlId="password-input">
                                                                <div className="float-end">
                                                                    <Link to="/forgot-password" className="text-muted">{t('Login.forget_password')}</Link>
                                                                </div>
                                                                <Form.Label>{t('Login.password')} <span className="text-danger">*</span></Form.Label>
                                                                <div className="position-relative auth-pass-inputgroup mb-3">
                                                                    <Form.Control
                                                                        type={passwordShow ? "text" : "password"}
                                                                        name='password'
                                                                        className="form-control bg-light border-light pe-5 password-input"
                                                                        placeholder="Enter password"
                                                                        value={validation.values.password || ""}
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        isInvalid={
                                                                            validation.touched.password && validation.errors.password ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.password && validation.errors.password ? (
                                                                        <Form.Control.Feedback type="invalid">{validation.errors.password}</Form.Control.Feedback>
                                                                    ) : null}
                                                                    <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}>
                                                                        <i className="ri-eye-fill align-middle"></i>
                                                                    </button>
                                                                </div>
                                                            </Form.Group>

                                                            <Form.Check className="mb-3" id="auth-remember-check">
                                                                <Form.Check.Input type="checkbox" />
                                                                <Form.Check.Label>{t('Login.remember_me')}</Form.Check.Label>
                                                            </Form.Check>

                                                                <div className="mt-2">
                                                                <Button className="btn btn-primary w-100" type="submit" disabled={loading}>{loading && <Spinner size='sm' /> } {" "}{t('Login.sign_in')} </Button>
                                                                </div>

                                                            </Form>
                                                        </div>

                                                    </Card.Body>
                                                </Col>

                                                <AuthCarousel/>
                                            </Row>
                                        </Card>

                                        <AuthFooter />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
    </React.Fragment>
  )
}

export default withRouter(Login);
